$(function() {
  const menuTarget = $('.js-toggle-nav-menu')
  $('.js-menu-toggle-open').on('click', function(e) {
    e.preventDefault();
    menuTarget.addClass('menu-open');
  });

  // メニューを閉じる
  $('.js-menu-toggle-close').on('click', function(e) {
    e.preventDefault();
    menuTarget.removeClass('menu-open');
  });

  $('.js-inner-menu-trigger').on('click', function(e){
    e.preventDefault();
    $(this).toggleClass('inner-menu-open');
    $(this).next('.js-inner-menu').toggle();
  });
});
